import React, { FunctionComponent } from "react";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

// Components
import { Icon } from "../../Icon";
// Styles
import "./NavBar.Component.scss";

const NavBarComponent: FunctionComponent = () => {
  const location = useLocation();
  const isAdmin = location.pathname.includes("/admin");

  return (
    <section className="nav">
      <div className="nav__icon__container">
        {!isAdmin ? (
          <HashLink
            scroll={(el) => {
              setTimeout(() => {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
              }, 1000);
            }}
            to="/#skip-to-content"
            state={{ prevPath: location.pathname }}
          >
            <Icon iconName="rtabak_icon" className="nav__icon" />
          </HashLink>
        ) : (
          <Link to={"/admin/see"}>
            <Icon iconName="rtabak_icon" className="nav__icon" />
          </Link>
        )}
      </div>
      {!isAdmin && (
        <div className="nav__list">
          <Link reloadDocument to={"/category/chain"}>
            {location.pathname == "/category/chain" ? (
              <p style={{ color: "black" }}>Cadenas</p>
            ) : (
              <p>Cadenas</p>
            )}
          </Link>
          <Link to={"/category/brazalete"} reloadDocument>
            {location.pathname == "/category/brazalete" ? (
              <p style={{ color: "black" }}>Pulseras</p>
            ) : (
              <p>Pulseras</p>
            )}
          </Link>
          <Link to={"/category/pendant"} reloadDocument>
            {location.pathname == "/category/pendant" ? (
              <p style={{ color: "black" }}>Dijes</p>
            ) : (
              <p>Dijes</p>
            )}
          </Link>
          <Link reloadDocument to={"/category/ring"}>
            {location.pathname == "/category/ring" ? (
              <p style={{ color: "black" }}>Anillos</p>
            ) : (
              <p>Anillos</p>
            )}
          </Link>
          <Link reloadDocument to={"/category/hoop"}>
            {location.pathname == "/category/hoop" ? (
              <p style={{ color: "black" }}>Aros</p>
            ) : (
              <p>Aros</p>
            )}
          </Link>
          <Link reloadDocument to={"/category/finding"}>
            {location.pathname == "/category/finding" ? (
              <p style={{ color: "black" }}>Fornituras</p>
            ) : (
              <p>Fornituras</p>
            )}
          </Link>
          <Link to={"/about-us"}>
            {location.pathname == "/about-us" ? (
              <p style={{ color: "black" }}>Nosotros</p>
            ) : (
              <p>Nosotros</p>
            )}
          </Link>
          <Link to={"/contact"}>
            {location.pathname == "/contact" ? (
              <p style={{ color: "black" }}>Contacto</p>
            ) : (
              <p>Contacto</p>
            )}
          </Link>
        </div>
      )}
    </section>
  );
};

export default NavBarComponent;
